import { render, staticRenderFns } from "./userLeaveDetails.vue?vue&type=template&id=478459f8&"
import script from "./userLeaveDetails.vue?vue&type=script&lang=js&"
export * from "./userLeaveDetails.vue?vue&type=script&lang=js&"
import style0 from "./userLeaveDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports